import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CUSTOMERS_RATING,
  DASHBOARD_ITEM_SOLD,
  GET_DASH_EARNING,
  GET_DASH_NEW_ORDER,
  GET_DASH_TOTAL_PRODUCTS,
  GET_PAST_TRENDS,
  GET_RECENT_ORDERS,
  GET_REVENUE,
  GET_REVIEW_REPORT_DATA,
  GET_SHOP_BY_CATEGORY,
  GET_TOP_SELLING_PRODUCTS,
  ORDER_STATISTICS,
} from "../../utils/queries";
import { createGraphQLThunk } from ".";

export const dashRevenuThunk = createAsyncThunk(
  "dashRevenuSlice/dashRevenuThunk",
  createGraphQLThunk({
    query: GET_REVENUE,
    getVariables: ({ dateFilter, categories }) => ({
      dateFilter,
      categories,
    }),
    responseKey: "getRevenue",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);

export const dashTopSellerProductsThunk = createAsyncThunk(
  "dashTopSellerProductsSlice/dashTopSellerProductsThunk",
  createGraphQLThunk({
    query: GET_TOP_SELLING_PRODUCTS,
    getVariables: ({ fromDate, toDate, inventoryId, paginationFilter }) => ({
      fromDate,
      toDate,
      inventoryId,
      paginationFilter,
    }),
    responseKey: "topSellingProducts",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);

export const dashPastTrendsThunk = createAsyncThunk(
  "dashPastTrendsSlice/dashPastTrendsThunk",
  createGraphQLThunk({
    query: GET_PAST_TRENDS,
    getVariables: ({ topSellingProduct }) => ({ topSellingProduct }),
    responseKey: "pastTrends",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);


export const GetOrderStatistics = createAsyncThunk(
  "orderStatisticsSlice/GetOrderStatistics",
  createGraphQLThunk({
    query: ORDER_STATISTICS,
    getVariables: (orderStage) => (orderStage),
    responseKey: "getOrderStatistics",
    url: process.env.REACT_APP_VENDOR,
    notError: true,
  })
);

export const recentOrdersThunk = createAsyncThunk(
  "recentOrdersSlice/recentOrdersThunk",
  createGraphQLThunk({
    query: GET_RECENT_ORDERS,
    getVariables: ({ paginationFilter }) => ({ paginationFilter }),
    responseKey: "getRecentOrders",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);

export const shopByCategoryThunk = createAsyncThunk(
  "shopByCategorySlice/shopByCategoryThunk",
  createGraphQLThunk({
    query: GET_SHOP_BY_CATEGORY,
    getVariables: ({ fromDate, toDate }) => ({ fromDate, toDate }),
    responseKey: "getSalesByCategory",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);

export const productReviewsThunk = createAsyncThunk(
  "productReviewsSlice/productReviewsThunk",
  createGraphQLThunk({
    query: GET_REVIEW_REPORT_DATA,
    getVariables: ({ paginationFilter }) => ({ paginationFilter }),
    responseKey: "getReviewReportData",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);

export const customRatingThunk = createAsyncThunk(
  "customRatingSlice/customRatingThunk",
  createGraphQLThunk({
    query: CUSTOMERS_RATING,
    getVariables: () => ({}),
    responseKey: "getCustomersRating",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);

export const dashboardItemSoldThunk = createAsyncThunk(
  "dashboardItemSoldSlice/dashboardItemSoldThunk",
  createGraphQLThunk({
    query: DASHBOARD_ITEM_SOLD,
    getVariables: () => ({}),
    responseKey: "getItemSold",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);

export const dashNewOrderThunk = createAsyncThunk(
  "dashNewOrderSlice/dashNewOrderThunk",
  createGraphQLThunk({
    query: GET_DASH_NEW_ORDER,
    getVariables: () => ({}),
    responseKey: "getNewOrder",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);

export const dashEarningThunk = createAsyncThunk(
  "dashEarningSlice/dashEarningThunk",
  createGraphQLThunk({
    query: GET_DASH_EARNING,
    getVariables: () => ({}),
    responseKey: "getEarning",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);

export const dashTotalProductsThunk = createAsyncThunk(
  "dashTotalProductSlice/dashTotalProductThunk",
  createGraphQLThunk({
    query: GET_DASH_TOTAL_PRODUCTS,
    getVariables: () => ({}),
    responseKey: "getTotalProduct",
    url: process.env.REACT_APP_VENDOR,
    notError: true
  })
);
